import React from 'react'
import PropTypes from 'prop-types'

import cn from '../../libs/class-name'

const News = ({ classNames, children }) => (
  <div className={cn('News', {}, classNames)}>{children}</div>
)

News.propTypes = {
  classNames: PropTypes.arrayOf(PropTypes.string),
  children: PropTypes.node.isRequired
}

export default News
